// Returns an object with app-specific location information
export default (location = window.location) => {
  const environments = [
    'lvh.me:9887',
    'lvh.me:3000',
    'localhost:3000',
    'localhost.localdomain:3333',
    'localhost',
    'qa0.contently.xyz',
    'qa1.contently.xyz',
    'qa2.contently.xyz',
    'qa3.contently.xyz',
    'qa4.contently.xyz',
    'qa5.contently.xyz',
    'qa6.contently.xyz',
    'qa7.contently.xyz',
    'qa8.contently.xyz',
    'qa9.contently.xyz',
    'qa10.contently.xyz',
    'canary.contently.com',
    'contently.biz',
    'snuffl.in',
    'contently.com'
  ];

  const windowHost = location.host.replace(location.protocol, '');
  const appHost = environments.filter(e => location.host === e || location.host.endsWith('.' + e))[0];

  const hasPortfolioName = windowHost.indexOf(appHost) > 0;
  const isLocal = /localhost|lvh\.me/.test(appHost);
  const portfolioName = hasPortfolioName ? windowHost.replace(`.${appHost}`, '') : '';

  let allDomains = hasPortfolioName ? windowHost.replace(portfolioName, '') : `.${windowHost}`;
   
  if (isLocal) allDomains = allDomains.split(':')[0];
  const hostWithoutPortfolioName = windowHost.replace(`${portfolioName}.`, '');

  return {
    portfolioName,
    hostWithoutPortfolioName,
    allDomains
  };
};
